import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducers from './redux/reducers';
import { rootSagas } from './configureSagas';

/* eslint-disable no-underscore-dangle */
const sagaMonitor = window.__SAGA_MONITOR_EXTENSION__;
const sagaMiddleware = createSagaMiddleware({ sagaMonitor });
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
  const store = createStore(
    rootReducers,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  sagaMiddleware.run(rootSagas);

  return store;
}
